export function validateBuildIdentity(
  version = __APP_VERSION__,
  commit = __APP_COMMIT__,
): void {
  if (!/^\d+\.\d+\.\d+$/.test(version)) {
    throw new Error(`App version must use major.minor.patch format, received "${version}"`)
  }
  if (commit !== 'development' && !/^[0-9a-f]{7,40}$/i.test(commit)) {
    throw new Error(`App commit must be a Git hash or "development", received "${commit}"`)
  }
}
